export class PaxCount {
    adultCount: number;
    childCount: number;
    infantCount: number;
    totalPax: number;
}
